import { gql, useQuery } from "@apollo/client";
import { format } from "date-fns";
import Link from "next/link";
import Button from "../../../../components/Atoms/Button";
import Loader from "../../../../components/Atoms/Loader";
import { formatDate } from "../../../../utils/calendarUtils";
import TourSignIcon from "../../../Atoms/TourSignIcon";

import { Iso639 } from "../../../../graphql/operations";
import styles from "./ProfileSchedule.module.scss";

interface AProps {
  guideId: string;
}

export default function ProfileSchedule({ guideId }: AProps) {
  const { loading, error, data } = useQuery(GET_GUIDE_GROUPS, {
    variables: {
      guideId,
      numGroups: 10,
      lang: Iso639.En,
    },
  });

  if (loading) {
    return <Loader />;
  }

  if (error || !data || !data.guideGroups) {
    return <>error</>;
  }

  const { guideGroups } = data;

  if (guideGroups.length === 0) {
    return <>Sorry, no schedule available</>;
  }

  return (
    <>
      {guideGroups.map((slot, index) => {
        return (
          <GuideScheduleCard
            key={index}
            slot={slot}
            product={slot.product}
            guide={guideId}
          />
        );
      })}
    </>
  );
}

const GET_GUIDE_GROUPS = gql`
  query GuideGroups($guideId: ID!, $numGroups: Int!, $lang: Iso639!) {
    guideGroups(guideId: $guideId, numGroups: $numGroups) {
      id
      date
      time
      product {
        id
        translation(lang: $lang) {
          name
        }
      }
    }
  }
`;

interface CheckoutUrlProps {
  product: {
    id: string;
  };
  guide?: string;
  date: string;
  time: string;
}

const checkoutUrl = ({ product, guide, date, time }: CheckoutUrlProps) => {
  const urlSearchParams = new URLSearchParams({
    date: formatDate(date),
    time: time,
    guideId: guide,
  });

  return `/checkout/${
    product.id
  }?${urlSearchParams.toString()}&ref=profile-schedule`;
};

interface GuideAvailabilityCardProps {
  product: {
    id: string;
    translation: {
      name: string;
    };
    poster: string;
  };
  guide?: string;
  slot: {
    date: string;
    time: string;
  };
}

function GuideScheduleCard({
  product,
  slot,
  guide,
}: GuideAvailabilityCardProps) {
  return (
    <div className={styles["GuideScheduleCard"]}>
      <div className={styles["GuideScheduleCardTime"]}>
        <b>
          {slot.time} / {format(new Date(slot.date), "MMM dd, yyyy")}
        </b>
      </div>
      <div className={styles["GuideScheduleCardContent"]}>
        <TourSignIcon size={34} />
        <p>{product.translation?.name ?? ""}</p>
      </div>
      <div className={styles["GuideScheduleCardBtn"]}>
        <Link
          href={checkoutUrl({
            product,
            date: slot.date,
            time: slot.time,
            guide: guide,
          })}
        >
          <Button>Book now</Button>
        </Link>
      </div>
    </div>
  );
}
